<template>
  <v-container fluid class="pa-0 ma-0">
    <pageHeader> CUSTOM APPLICATIONS </pageHeader>
    <UnderLinedHeader class="pt-15 pb-8 white">
      Custom Applications for Complex Problems.
    </UnderLinedHeader>

    <v-row justify="center" align="center" class="px-16 mb-16">
      <p class="artice-text text-center px-16">
        As a business owner, you are no stranger to obstacles that seem to come
        out of left field. Unexpected roadblocks that get in the way of your
        team’s productivity or endanger your ability to serve clients.
      </p>
      <p class="artice-text text-center px-16">
        At 35*45 Consulting-Global we recognize the need for ‘Outside of the
        Box’ thinking when it comes to finding solutions for those unexpected
        situations. As well as the value that custom applications provide when
        traditional software doesn’t deliver exactly what the business or client
        needs.
      </p>
    </v-row>

    <v-row justify="center" align="center" class="greyBG px-16 mt-4">
      <UnderLinedHeader class="pt-15 pb-8 '#f8f9f9'">
        No Project is Too Great or Too Small.
      </UnderLinedHeader>
      <p class="artice-text text-center px-16 pb-15">
        When it comes to solving a complex problem, something that seems too
        small for custom application development might be the perfect fit.
        Clients often come to us after many rounds of trial and error trying to
        find a solution for a ‘small problem.’ Then, after a discovery session
        with our team find that developing a custom tool for their business was
        the best route all along.
      </p>
    </v-row>


    <CaseStudy
      text="When a large client changed to a different technology platform,
            Ermer Law Group called on the engineering expertise of the 35*45
            Consulting team. Their dedication to building a custom application
            not only solved the problem but strengthened the relationship with
            the client."
      link="https://secureservercdn.net/45.40.152.13/l8e.e3d.myftpupload.com/wp-content/uploads/case_studies/Case_Study-Ermer.pdf"
      color="white"
      caseStudyText="Read the Ermer Law Group, PLLC Case Study and learn more about
              how our team can solve for the unknown in nearly any
              situation."
      say=" “The 3545 Team took interest and ownership in solving the problem.
          They were great to work with and knew the right questions to ask of us
          and our client to get the job done.”"
      dashedSay="— Jason Suter, Ermer Law Group"
    >
      <template v-slot:header>
        <underLinedHeader class="pt-0 pb-6 white">
            Ermer Law Group, PLLC</underLinedHeader
          >
      </template>
      <template v-slot:image>
        <v-img
            contain
            :height="imgSize"
            :src="require('@/assets/imgs/Services/Harris-Case-Study-600px.png')"
            :lazy-src="
              require('@/assets/imgs/Services/Harris-Case-Study-600px.png')"
          >
          </v-img>
      </template>
    </CaseStudy>
  </v-container>
</template>

<script>
import PageHeader from "@/components/global/compnentsMixins/PageHeader.vue";
import UnderLinedHeader from "@/components/global/compnentsMixins/UnderLinedHeader.vue";
import CaseStudy from "@/components/global/compnentsMixins/CaseStudy.vue";
import ImgesMixin from "@/components/global/mixins/ImgesMixin.js";
export default {
  components: { PageHeader, UnderLinedHeader, CaseStudy },
  mixins: [ImgesMixin]
};
</script>

